import { render, staticRenderFns } from "./Tissue.vue?vue&type=template&id=5438c83f&scoped=true&"
import script from "./Tissue.vue?vue&type=script&lang=js&"
export * from "./Tissue.vue?vue&type=script&lang=js&"
import style0 from "./Tissue.vue?vue&type=style&index=0&id=5438c83f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438c83f",
  null
  
)

export default component.exports